module.exports = __webpack_public_path__ + "media/assets/icons/carousel-third-20a83a7d231d9623f6926d154d8fad37.png";